export const webNotification = require('./notification.mp3');



// WEBPACK FOOTER //
// ./src/data/assets/audio/index.js